import { useContext } from 'react';
import { User, UserContext, UserState } from './UserContext';

export const useUser = (): User => {
  const userStatus = useContext(UserContext);

  if (userStatus.state === UserState.SignedIn) {
    return userStatus as User;
  }

  throw new Error("useUser hook can only be used inside of components contained inside an UserTemplate component");
}